import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {ReactNodeGenerator} from '../../../../lib/helpers';
import {StaticImageEditStore} from './StaticImageEditStore';

export function* staticImageEditStoreRenderer(store: StaticImageEditStore): ReactNodeGenerator {
  const {imageUrl, imageFile, imageUpload} = store;

  if (imageUrl === null) {
    yield (
      <div className="row no-gutters" key="1">
        <div className="col-md-4 col-xs-6">
          <div className="form-group">
            <label>Image</label>
            <input type="file" className="form-control-file"
                   onChange={store.handleImageFileChange}/>
          </div>
        </div>
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  disabled={imageFile === null || imageUpload?.isPending === true}
                  onClick={store.uploadImage}>
            Upload
          </button>
        </div>
      </div>
    );
    yield (
      <PromiseMessage key="2"
                      label="Uploading" state={imageUpload} align="right"/>
    );
  }

  if (imageUrl !== null) {
    yield (
      <div className="row" key="3">
        <div className="col">
          <div className="static-image-container">
            <img className="static-image" src={imageUrl} alt="Image not found"/>
          </div>
        </div>
      </div>
    );

    yield (
      <div className="row justify-content-end" key="5">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.clearImage}>
            Clear
          </button>
        </div>
      </div>);
  }
}
